import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { TAuthenticationMethod } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface IFetchAvailableAuthMethods extends RequestInit {
  apiUrl: string;
  apikey?: string;
  ctrl?: QueryController;
  sessionKey?: string;
}

export const createRequest = (opts: IFetchAvailableAuthMethods): Request => {
  const { apiUrl, apikey, sessionKey, ...restOpts } = opts;
  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(`methods`).build().toString();

  const headers = createHeaders({
    /* If the apikey is something else then undefined its added */
    "ARGUS-API-KEY": apikey,
    Accept: "application/json",
    "Content-Type": "application/json",
  });
  let localRequestOpts: RequestInit = {
    headers,
    method: "GET",
    mode: "cors",
  };
  if (!apikey) {
    /**
     * Only add cookies if no apikey is provided
     */
    localRequestOpts = {
      ...localRequestOpts,
      credentials: "include",
    };
  }
  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function fetchAvailableAuthMethods(
  opts: IFetchAvailableAuthMethods,
): Promise<JsonQuery<IResultstash<TAuthenticationMethod[]>>> {
  return await fetchJsonQuery<IResultstash<TAuthenticationMethod[]>>(createRequest(opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default fetchAvailableAuthMethods;
